const stores = [
  "※ スムーズ仲介1",
  "※ スムーズ仲介2",
  "※ スムーズ仲介3",
  "※ スムーズ仲介池尻大橋店",
  "株式会社リアリースエージェント",
  "＃スーペリアホーム御茶ノ水店",
  "＃株式会社L&Dアパートメント",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！下北沢店",
  "(閉店) 株式会社エスフィット お部屋探しCAFE ヘヤギメ！阿佐ヶ谷店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！錦糸町店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！御茶ノ水店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！高円寺店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！川崎店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！池袋店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！鶴見店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！目黒店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！門前仲町店",
  "＃株式会社エスフィット お部屋探しCAFE ヘヤギメ！六本木店",
  "＃株式会社Unit",
  "(取引停止)ハウスウェブ株式会社 草加店",
  "えびす不動産",
  "(未契約)株式会社エストラスト 横浜店",
  "(未契約)株式会社エストラスト 溝の口店",
  "(取引停止)株式会社LUX 立川店",
  "＃株式会社グッドルーム 八王子店",
  "株式会社グッドルーム 町田店",
  "＃株式会社ハウスパートナー 綾瀬店",
  "＃株式会社ハウスパートナー 押上店",
  "＃株式会社ハウスパートナー 亀有店",
  "＃株式会社ハウスパートナー 錦糸町店",
  "＃株式会社ハウスパートナー 金町店",
  "＃株式会社ハウスパートナー 松戸店",
  "(閉店) 株式会社ハウスパートナー 新越谷店",
  "＃株式会社ハウスパートナー 西新井店",
  "＃株式会社ハウスパートナー 西船橋店",
  "＃株式会社ハウスパートナー 青戸店",
  "＃株式会社さくらハウジング",
  "＃株式会社ハウスパートナー 草加店",
  "＃株式会社ハウスパートナー 町屋店",
  "＃株式会社ハウスパートナー 北千住店",
  "＃株式会社ハウスパートナー 本八幡店",
  "＃株式会社ティアホーム",
  "Work Full House",
  "東和開発株式会社 sumica 武蔵関店",
  "＃有限会社矢島",
  "＃株式会社部屋市場",
  "(未契約)株式会社博進 コスモプラザ",
  "株式会社クレストリッチ",
  "＃株式会社ハウスパートナー 南流山店",
  "＃株式会社ハウスパートナー 葛西店",
  "株式会社NBIファイナンシャルグループ",
  "＃株式会社ハナインターナショナル調布駅前支店",
  "＃株式会社ハナインターナショナル浦安駅前支店",
  "株式会社ビッグ 渋谷店",
  "(取引停止)結家不動産コンサルティング株式会社",
  "トラスト・レジデンス 森下店",
  "トラスト・レジデンス 秋葉原店",
  "＃株式会社ハウスパートナー 新松戸店",
  "＃株式会社ハナインターナショナル北千住本店",
  "＃株式会社ハナインターナショナル松戸駅前支店",
  "＃株式会社ハナインターナショナル草加駅前支店",
  "＃株式会社ハナインターナショナル川崎駅前支店",
  "＃株式会社ハナインターナショナル　京橋駅前支店",
  "トラスト・レジデンス神保町本店",
  "※株式会社e.cubed",
  "＃リロの賃貸 多摩センター店",
  "＃リロの賃貸 永山駅前店",
  "＃リロの賃貸　レックス大興 大宮本店",
  "＃リロの賃貸　レックス大興 大宮西口店",
  "＃リロの賃貸　レックス大興 東大宮店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　蒲田店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　蒲田西口店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　京急蒲田店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　大森駅ビルRaRa店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　大井町店",
  "(取引停止)リロの賃貸 株式会社リーベハウス　池上店",
  "＃株式会社ソーシャルスマイル",
  "Haus Mediation株式会社",
  "＃君島ホールディングス株式会社",
  "株式会社ニューライフオリジナル　伊勢原店",
  "株式会社ニューライフオリジナル　平塚店",
  "株式会社ニューライフオリジナル　海老名店",
  "株式会社ニューライフオリジナル　町田店",
  "株式会社ニューライフオリジナル　青葉台店",
  "株式会社ニューライフオリジナル　中央林間店",
  "＃株式会社ニューライフオリジナル　湘南台店",
  "＃ピタットハウス 岩槻店",
  "エキマエホーム　溝の口店",
  "エキマエホーム　武蔵小杉店",
  "＃有限会社 城北商事不動産部",
  "(未契約)株式会社トレット",
  "※KEIAI 東大宮駅前不動産センター",
  "●アエラス日暮里店",
  "(閉店)アエラス竹ノ塚店",
  "●アエラス綾瀬店",
  "●アエラス新小岩店",
  "●アエラス錦糸町店",
  "●アエラス葛西店",
  "●アエラス中野店",
  "●アエラス荻窪店",
  "●アエラス練馬店",
  "●アエラス御茶ノ水店",
  "●アエラス新橋店",
  "●アエラス武蔵小山店",
  "●アエラス目黒店",
  "●アエラス学芸大学店",
  "●アエラス蒲田店",
  "●アエラス下北沢店",
  "●アエラス駒沢大学店",
  "(閉店)アエラス祖師ヶ谷大蔵店",
  "●アエラス巣鴨店",
  "●アエラス駒込店",
  "●アエラス赤羽店",
  "●アエラス十条店",
  "(閉店)アエラス王子店",
  "●アエラス板橋店",
  "●アエラス大山店",
  "●アエラス八王子店",
  "●アエラス立川店",
  "●アエラス吉祥寺店",
  "●アエラス三鷹店",
  "●アエラス調布店",
  "(利用一時停止中)●アエラス国分寺店",
  "●アエラスひばりヶ丘店",
  "●アエラス川崎店",
  "●アエラス大宮店",
  "●アエラス南浦和店",
  "●アエラス川口店",
  "●アエラス所沢店",
  "●アエラス新越谷店",
  "●アエラス市川店",
  "●アエラス船橋店",
  "●アエラス津田沼店",
  "●アエラス松戸店",
  "●アエラス柏店",
  "●ソレイユ神田店",
  "●ソレイユ高田馬場店",
  "●ソレイユ新宿店",
  "●ソレイユ代々木店",
  "●ソレイユ渋谷店",
  "●ソレイユ恵比寿店",
  "●ソレイユ上野店",
  "●ソレイユ五反田店",
  "●ソレイユ池袋店",
  "●ソレイユ横浜店",
  "※ グランデ銀座店",
  "※ グランデ日本橋店",
  "※ グランデ新宿店",
  "※ グランデ上野店",
  "※ グランデ池袋店",
  "＃毎日住宅流通株式会社",
  "(未契約)株式会社レオンワークス",
  "株式会社ネクストプラス",
  "＃ReLife（株式会社和社）",
  "株式会社エムスタイル",
  "(未契約)キシマエ・ハウジング",
  "(未契約)Limitless株式会社",
  "(未契約)小美不動産",
  "株式会社生活設計オフィス",
  "＃株式会社FORiE",
  "株式会社ジェットシティーズ",
  "(未契約)LinkNavi梅田店",
  "(未契約)LinkNavi福島店",
  "(取引停止)レイワ不動産 大国町店",
  "(取引停止)レイワ不動産 玉造店",
  "(取引停止)レイワ不動産 今里店",
  "株式会社en company",
  "株式会社グローバルエステート",
  "(未契約)アイデアキューブ株式会社",
  "株式会社カインドトラスト",
  "（閉店）ReLife 福島野田店",
  "(取引停止)アンサー倶楽部 小倉店",
  "ホームメイトＦＣ御器所駅前店（エステートプラス株式会社）",
  "＃レジデンシャルゴールド関内本店",
  "＃レジデンシャルゴールド新横浜アリーナ通り店",
  "＃レジデンシャルゴールド横浜店",
  "＃レジデンシャルゴールド川崎店",
  "＃レジデンシャルゴールド町田店",
  "＃レジデンシャルゴールド大宮店",
  "＃レジデンシャルゴールド新横浜駅前店",
  "＃ 湘南乃家",
  "＃ レジデンシャルゴールド藤沢店",
  "ピタットハウス本町店（株式会社スピーディー）",
  "●アエラス北千住店",
  "中村不動産",
  "株式会社 栄信不動産",
  "＃福岡ふたば不動産",
  "アンドエステート姪浜店",
  "＃アンドエステート春日原店",
  "アンドエステートBranch博多パピヨン前店",
  "＠株式会社コーユーハウス",
  "住まいるパートナーズ",
  "(未契約)スタイルプラス福岡(株式会社リブシル)",
  "ホームメイトFC弁天町店（有限会社レジデンス21）",
  "イースマイル　博多店",
  "株式会社アンサー俱楽部 本店",
  "イースマイルJR久留米店",
  "※株式会社エニシス",
  "※株式会社ビッグ 福岡店",
  "トーマスリビング 博多本店",
  "＃トーマスリビング 空港前店",
  "トーマスリビング 飯塚店",
  "トーマスリビング 粕屋店",
  "トーマスリビング 鳥栖店",
  "トーマスリビング 赤間店",
  "トーマスリビング 福間店",
  "＃トーマスリビング 大橋店",
  "※トーマスリビング 六本松店",
  "トーマスリビング 古賀店",
  "トーマスリビング 二日市店",
  "＃トーマスリビング 西新店",
  "トーマスリビング 天神店",
  "トーマスリビング 香椎店",
  "トーマスリビング 春日原店",
  "トーマスリビング 博多駅前店",
  "トーマスリビング 小倉店",
  "トーマスリビング 下曽根店",
  "トーマスリビング 折尾店",
  "トーマスリビング 黒崎店",
  "トーマスリビング 戸畑店",
  "トーマスリビング 三ヶ森店",
  "＃株式会社ニューライフオリジナル　厚木本店",
  "※ 合同会社オンラインエージェンシー",
  "※株式会社よすむ不動産",
  "(閉店)Room's 北浜店",
  "株式会社アンティ 天六店",
  "株式会社エリッツ",
  "株式会社リテート",
  "※株式会社シエバ",
  "（閉店）株式会社ジャパンリアルティ",
  "RE/MAX Revo（リマックス レボ）",
  "※ゆりの不動産",
  "(未契約)株式会社agent table",
  "(未契約)株式会社Sun Lead",
  "※SHIFT-HOME",
  "※プラスワン",
  "株式会社クレディフォルム",
  "●アエラス登戸店",
  "※有限会社ピースホーム　大阪支店",
  "ワールド総合建物",
  "株式会社リテート　福岡営業所",
  "株式会社リテート　大阪営業所",
  "プラスワン",
  "スタンダード不動産",
  "アエラスグループ お客様サポートセンター",
  "HOMELIFE",
  "RE/MAX　L-style",
  "幸和JAPAN",
  "RE/MAX　NOW",
  "＃株式会社ハウスパートナー 日暮里店",
  "＃ライジングコーポレーション",
  "大励エステート",
  "(取引停止)イーコムハウジング",
  "(取引停止)ペアラボ姫路本店",
  "(取引停止)ペアラボ姫路駅前店",
  "うちトク不動産 本店",
  "※ cocoroom",
  "●アエラス府中店",
  "●アエラス藤沢店",
  "(閉店)嶺山エステート 本店",
  "賃貸クラウド 千葉蘇我店",
  "株式会社ソリューション",
  "※ 株式会社日本財託管理サービス",
  "※株式会社Resume",
  "＃賃貸ホームズ本店",
  "※有限会社松尾商会",
  "＃レジデンシャルゴールド　本部",
  "スタイルホーム㈱豊橋店",
  "ホームメイトＦＣ中村公園駅前店",
  "＃スタイルホーム株式会社　豊田店",
  "ライブラリーホームズ",
  "アパマンショップ阿佐ヶ谷店",
  "ホームメイトFC鶴舞駅前店",
  "※ホームメイトFC東海通駅前店",
  "ホームメイトFC千種駅前店",
  "＃レントライズ不動産",
  "●アエラス西葛西店",
  "＠株式会社ワイアールコーポレーション",
  "⚫️エリッツ 北大路店",
  "(閉店)⚫️エリッツ 佛教大学前店",
  "⚫️エリッツ 立命館大学前店",
  "⚫️エリッツ 白梅町店",
  "⚫️エリッツ 今出川店",
  "⚫️エリッツ 北山店",
  "⚫️エリッツ 京都芸術大学前店",
  "⚫️エリッツ 京都大学前店",
  "⚫️エリッツ 出町柳店",
  "⚫️エリッツ 円町店",
  "⚫️エリッツ 烏丸丸太町店",
  "⚫️エリッツ 二条駅前店",
  "⚫️エリッツ 河原町三条店",
  "⚫️エリッツ 三条柳馬場店",
  "⚫️エリッツ 四条大宮店",
  "⚫️エリッツ 七条京阪店",
  "⚫️エリッツ 四条烏丸店",
  "⚫️エリッツ 四条河原町店",
  "(閉店)⚫️エリッツ 烏丸五条店",
  "⚫️エリッツ 京都駅前店",
  "⚫️エリッツ 西大路駅前店",
  "⚫️エリッツ 太秦店",
  "⚫️エリッツ 西院店",
  "⚫️エリッツ 西京極店",
  "⚫️エリッツ 深草店",
  "⚫️エリッツ 竹田店",
  "⚫️エリッツ 伏見桃山店",
  "⚫️エリッツ 山科店",
  "⚫️エリッツ 椥辻店",
  "⚫️エリッツ 桂店",
  "⚫️エリッツ 福知山店",
  "⚫️エリッツ 六地蔵店",
  "⚫️エリッツ 宇治小倉店",
  "⚫️エリッツ 亀岡駅前店",
  "⚫️エリッツ 長岡天神店",
  "⚫️エリッツ 新田辺店",
  "⚫️エリッツ 園部駅西口店",
  "⚫️エリッツ 堅田店",
  "⚫️エリッツ 大津駅前店",
  "⚫️エリッツ 瀬田店",
  "⚫️エリッツ 石山店",
  "⚫️エリッツ 長浜店",
  "⚫️エリッツ 草津駅前店",
  "⚫️エリッツ 南草津店",
  "⚫️エリッツ 守山店",
  "⚫️エリッツ 水口店",
  "⚫️エリッツ 野洲店",
  "⚫️エリッツ ＪＲ高槻店",
  "⚫️エリッツ 阪急茨木市店",
  "⚫️エリッツ ＪＲ茨木店",
  "⚫️エリッツ ＪＲ千里丘店",
  "(取引停止)株式会社AZUREPLANNING",
  "Win-Win 豊橋店",
  "株式会社チアエステート",
  "MAMAHOME",
  "有限会社アイコー不動産",
  "※株式会社デザイアホーム",
  "※株式会社クイックエステート",
  "⚫️エリッツ 彦根駅前店",
  "⚫️エリッツ 新祝園せいかガーデンシティ店",
  "⚫️エリッツ 西大寺店",
  "王子のSUMA・i・E 赤羽店",
  "アイランドエステート駒沢大学店",
  "COCO SMILE",
  "(閉店)door to株式会社",
  "株式会社STYプランニング本店",
  "＃株式会社エスフィット お部屋探しCAFEヘヤギメ！三軒茶屋店",
  "ホームメイトFC三軒茶屋南口店",
  "住まい探しのSumuSumu九条店",
  "RE/MAX WISH",
  "株式会社AZOX",
  "ALBAプロパティーズ株式会社",
  "●アエラス目白店",
  "(未契約)株式会社タナハラ",
  "レジスタ合同会社",
  "RE/MAX Bloom北武開発株式会社",
  "※合同会社IEMACHI",
  "お部屋探しならリルーム",
  "※K&M不動産",
  "＠ハイツリー株式会社",
  "※株式会社ミルーム",
  "(閉店)ピタットハウス新栄町葵店",
  "●アエラス川越店",
  "※ティエスマネジメント株式会社",
  "ROOMPIA",
  "※TEKIZAN株式会社",
  "(取引停止)サンエイホーム",
  "#リライフ",
  "※株式会社リーテック",
  "※有限会社リーウェイズ",
  "合同会社Confidence Agency",
  "※株式会社ルームコネクト",
  "※一心エステート",
  "※ グランデ田町店",
  "●アエラス町田店",
  "●アエラス橋本店",
  "●アエラス千葉店",
  "株式会社アグリブート",
  "へやなび 横濱関内店",
  "株式会社リスム",
  "J.I CORPORATION株式会社",
  "※地文株式会社",
  "(取引停止)LIXIL不動産ショップC'z Style",
  "⚫️エリッツ くずは店",
  "●アエラス石神井公園店 ",
  "●ソレイユ溝の口店",
  "株式会社渋谷不動産",
  "合同会社スタイルファクトリー",
  "＃なるせ不動産",
  "※株式会社LiELU 本店",
  "※株式会社ミレイホーム",
  "株式会社SKルーム",
  "＃株式会社ShineDays",
  "合同会社LEOSENSE",
  "※株式会社ゼロプラ",
  "グレスリンク株式会社",
  "※藤原建設株式会社",
  "株式会社Copres",
  "エンカウンター株式会社",
  "※株式会社B.D.M",
  "SAGASSO",
  "株式会社住まいリース",
  "株式会社アルファブレインジャパン",
  "株式会社プラスエステートホーム",
  "※ユーエルネット 尼崎店",
  "RE/MAX ONE",
  "※goodroom",
  "⚫️エリッツ 奈良新大宮店",
  "⚫️エリッツ 天理店",
  "⚫️エリッツ 大和八木店",
  "⚫️エリッツ 生駒店",
  "※株式会社Bruce Home",
  "※株式会社エミシアエステート",
  "株式会社グランクリエイト",
  "※ユーエルネット江坂店",
  "※株式会社S-KH",
  "ハウスパートナー津田沼店",
  "株式会社AGトラスト",
  "株式会社my room",
  "RE/MAX KYOUEI",
  "※シェルビー不動産",
  "※XROOMS(エックスルームス)",
  "⚫️エリッツ 枚方市駅前店",
  "⚫️エリッツ 西舞鶴店",
  "※株式会社Cy",
  "株式会社SUMOMIT",
  "株式会社TERASS",
  "上汐地所株式会社",
  "※株式会社セレクトハウス",
  "※anybody株式会社",
  "※COCO House",
  "※アリア株式会社",
  "※Steer Ship株式会社",
  "※株式会社Pao Homes",
  "※株式会社イールーム 春日店",
  "※START株式会社",
  "※久和不動産株式会社",
  "※エイブルネットワーク松山南店",
  "※エイブルネットワーク松山市駅西店",
  "※株式会社アンドライフ",
  "※ユージーハウス株式会社",
  "※株式会社グッドプロパティ",
  "Prime Residential合同会社",
  "スムーズ開発用ストア",
  "株式会社エムワイホーム",
]

export const storesOptions = stores.map((store) => {
  return {
    value: store,
    label: store,
  }
})

export const strategyValueObject = {
  basic: "通常",
  feeDiscount: "手数料割引",
  fullReimbursement: "全額立替",
  jukyakuTaxIncluded30Percent: "店舗利用(税込30%)",
  jukyakuTaxIncluded16_5Percent: "店舗利用(税込16.5%)",
  jukyakuTaxIncluded0Percent: "店舗利用(税込0%)",
  alphaBrain: "アルファブレイン",
  anybodyWithAd: "anybody(ADあり)",
  anybodyWithoutAd: "anybody(ADなし)",
  eCompany: "e-company",
  elitz: "エリッツ",
  globalEstate: "グローバルエステート",
  hanaInternational: "ハナインターナショナル",
  reMaxRevoWithoutAd: "RE/MAX Revo(ADなし)",
  housePartner: "ハウスパートナー",
  riaHouseWithoutAd: "リアハウス(ADなし)",
  riaHouseWithAd: "リアハウス(ADあり)",
  sFit: "S-FIT",
  thomasLiving: "トーマスリビング",
  houseCorporation: "ハウスコーポレーション",
} as const

// オブジェクトの値からリテラル型を生成
export type StrategyValue = (typeof strategyValueObject)[keyof typeof strategyValueObject]

export const strategyOptions = Object.values(strategyValueObject).map((value) => ({
  value,
  label: value,
}))

export const isRecipientOptions = [
  { value: "true", label: "YES" },
  { value: "false", label: "NO" },
]

export enum NumberOfPayments {
  Undecided = -1,
  Split3 = 3,
  Split6 = 6,
  Split12 = 12,
  Split24 = 24,
  Split36 = 36,
  Split48 = 48,
}

export const numberOfPaymentsValues = Object.values(NumberOfPayments).filter(
  (value): value is number => typeof value === "number"
)

export const nopOptions = [
  { value: NumberOfPayments.Undecided, label: "未定" },
  { value: NumberOfPayments.Split3, label: "3回" },
  { value: NumberOfPayments.Split6, label: "6回" },
  { value: NumberOfPayments.Split12, label: "12回" },
  { value: NumberOfPayments.Split24, label: "24回" },
  { value: NumberOfPayments.Split36, label: "36回" },
  { value: NumberOfPayments.Split48, label: "48回" },
]

export enum PaymentMethod {
  Undecided = 0,
  GMOAdvancePayment = 1,
  SmoothDirectPayment = 2,
}

export const paymentMethodsValues = Object.values(PaymentMethod).filter(
  (value): value is number => typeof value === "number"
)

export const paymentMethodOptions = [
  { value: PaymentMethod.Undecided, label: "未定" },
  { value: PaymentMethod.GMOAdvancePayment, label: "GMO立替" },
  { value: PaymentMethod.SmoothDirectPayment, label: "SMOOTH直払い" },
]
